export default __webpack_public_path__ + "static/media/314.44fe6cfa.gif";